<div class="modal-header">
  <div class="modal-title">
    @if (title) {
      <h3 class="mb-0">{{ title }}</h3>
    }
    @if (message) {
      <p class="modal-subtitle mb-0">{{ message }}</p>
    }
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  @if (enableFiltering) {
    <div class="form-group mb-3">
      <input
        type="text"
        [(ngModel)]="filterText"
        class="form-control"
        placeholder="Search…"
        (keyup)="filter(filterText)"
      />
    </div>
  }

  @if (displaySelectionsAsTags && SelectionTags.size > 0) {
    <div class="selection-tags">
      @for (SelectionTag of SelectionTags; track SelectionTag) {
        <span class="selection-tag">
          {{ SelectionTag.bodyText }}
          <button
            type="button"
            class="selection-tag__remove"
            (click)="removeSelectionTag(SelectionTag)"
            aria-label="Remove {{ SelectionTag.bodyText }}"
          >
            <i class="bi bi-x-lg"></i>
          </button>
        </span>
      }
    </div>
  }

  <div class="accordion-wrap" ngbAccordion>
    @for (
      accordionCardCollection of accordionCardCollectionArray;
      track accordionCardCollection
    ) {
      @if (!accordionCardCollection.hidden) {
        <div ngbAccordionItem [collapsed]="collapsed">
          <div ngbAccordionHeader>
            <button ngbAccordionButton class="accordion-title">
              {{ accordionCardCollection.title }}
            </button>
          </div>
          <div ngbAccordionCollapse>
            <div
              class="accordion-body-override"
              ngbAccordionBody
              (click)="checkLimit()"
            >
              <app-card-column
                class="card-column"
                [ngClass]="{
                  disabled:
                    SelectionTags.size === selectionModel?.selectionLimit
                }"
                [enableSelection]="
                  selectionModel ? selectionModel.selectionType : false
                "
                (cardClick)="cardClicked($event)"
                [cardCollection]="accordionCardCollection.cardCollection"
              ></app-card-column>
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      {{ cancelButtonText }}
    </button>
    <button type="button" class="btn btn-primary" (click)="continue()">
      {{ continueButtonText }}
    </button>
  </div>
</div>
